import { useState } from 'react';
import { Box, Chip, IconButton, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FieldInfoLabel from '../FieldInfoLabel';

type Props = {
  nameKey: string;
  name?: string;
  value: any;
  onChange: (nameKey: string, value: string[]) => void;
  required?: boolean;
  description?: string;
  placeholder?: string;
};

const CustomPropertyListSingle = ({ nameKey, name, value, onChange, required, description, placeholder }: Props) => {
  const [inputValue, setInputValue] = useState('');
  const items: string[] = Array.isArray(value) ? value : [];

  const handleAdd = () => {
    const trimmed = inputValue.trim();
    if (!trimmed) return;
    onChange(nameKey, [...items, trimmed]);
    setInputValue('');
  };

  const handleDelete = (index: number) => {
    onChange(nameKey, items.filter((_, i) => i !== index));
  };

  return (
    <Box sx={{ width: '100%', mt: '10px' }}>
      <TextField
        size="small"
        variant="standard"
        label={<FieldInfoLabel label={name ?? nameKey} description={description} />}
        value={inputValue}
        placeholder={placeholder || ''}
        fullWidth
        required={required && items.length === 0}
        InputLabelProps={{ shrink: true }}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleAdd();
          }
        }}
        InputProps={{
          endAdornment: (
            <IconButton size="small" onClick={handleAdd} disabled={!inputValue.trim()}>
              <AddIcon fontSize="small" />
            </IconButton>
          ),
        }}
      />
      {items.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
          {items.map((item, i) => (
            <Chip key={i} label={item} size="small" onDelete={() => handleDelete(i)} />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CustomPropertyListSingle;
